export var 碰蛋成功 = {
  'data': {
    'act_name': 'fulishe_dft',
    'actid': 'fulishe_dft',
    'guest_lottery_info': {
      'property_name': '煮蛋器',
      'property_result': 1,
      'property_url': 'https://puui.qpic.cn/vshpic/0/D7215E022460D104F0ACD34F268EE41A1558433120/0'
    },
    'master_lottery_info': {
      'property_name': '腾讯视频100漫画券',
      'property_result': 1,
      'property_url': 'https://puui.qpic.cn/vshpic/0/3D569B40BDB38D8FC3952C1544B827291539225948/0'
    }
  },
  'msg': 'OK',
  'ret': 0
};
export var 碰蛋出错 = {
  'msg': '抽奖失败',
  'ret': -1020
};
export var 有蛋 = {
  'data': {
    'egg_count': 3,
    'egg_name': '普通蛋2',
    'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_dja6unp16w5/0',
    'egg_type': 1,
    'is_played': 0,
    'is_recved': 1,
    'is_shaked': 0,
    'is_yesrecved': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 未领取 = {
  'data': {
    'egg_count': 0,
    'egg_name': '普通蛋2',
    'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_dja6unp16w5/0',
    'egg_type': 1,
    'is_played': 0,
    'is_recved': 0,
    'is_shaked': 0,
    'is_yesrecved': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 领蛋成功 = {
  'data': {
    'egg_count': 3,
    'egg_type': 0,
    'is_upgrade': false
  },
  'msg': 'ok',
  'ret': 0
};
export var 碰蛋自己没中奖 = {
  'data': {
    'act_name': 'fulishe_dft',
    'actid': 'fulishe_dft',
    'guest_lottery_info': {
      'property_name': '',
      'property_result': 0,
      'property_url': ''
    },
    'master_lottery_info': {
      'property_name': '腾讯视频100漫画券',
      'property_result': 1,
      'property_url': 'https://puui.qpic.cn/vshpic/0/3D569B40BDB38D8FC3952C1544B827291539225948/0'
    }
  },
  'msg': 'OK',
  'ret': 0
};
export var 碰蛋对方没中奖 = {
  'data': {
    'act_name': 'fulishe_dft',
    'actid': 'fulishe_dft',
    'guest_lottery_info': {
      'property_name': '煮蛋器',
      'property_result': 1,
      'property_url': 'https://puui.qpic.cn/vshpic/0/D7215E022460D104F0ACD34F268EE41A1558433120/0'
    },
    'master_lottery_info': {
      'property_name': '',
      'property_result': 0,
      'property_url': ''
    }
  },
  'msg': 'OK',
  'ret': 0
};
export var 碰蛋双方没中奖 = {
  'data': {
    'act_name': 'fulishe_dft',
    'actid': 'fulishe_dft',
    'guest_lottery_info': {
      'property_name': '',
      'property_result': 0,
      'property_url': ''
    },
    'master_lottery_info': {
      'property_name': '',
      'property_result': 0,
      'property_url': ''
    }
  },
  'msg': 'OK',
  'ret': 0
};
export var 今天还未碰蛋 = {
  'data': {
    'act_name': 'fulishe_dft',
    'actid': 'fulishe_dft',
    'is_today_collision': 0,
    'is_your_code': 0,
    'master_eggs_info': {
      'egg_name': '镀金彩蛋',
      'egg_skin_url': 'https://puui.qpic.cn/vupload/0/1561101327730_l1mnw2i06y/0',
      'eggs_count': 3,
      'eggs_type': 1
    },
    'master_vip_info': {
      'master_id': '135051317',
      'master_is_annual_vip': 1,
      'master_is_vip': 1,
      'master_name': '追风筝的人',
      'master_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=tnS2uicibpMmqicnrqP3dHM5A&s=140&t=1555301651',
      'master_vip_level': 8,
      'master_long_icon_url': 'https://puui.qpic.cn/vupload/0/20190428_Star_3x.png/0'
    },
    'personal_code_status': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 主人蛋不足 = {
  'data': {
    'eggs_count': 0,
    'eggs_pic': '',
    'eggs_type': 0,
    'is_today_collision': 0,
    'is_your_code': 0,
    'master_background_url': '',
    'master_big_url': '',
    'master_id': '135051317',
    'master_is_annual_vip': 1,
    'master_is_vip': 1,
    'master_name': '追风筝的人',
    'master_type': 1,
    'master_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=tnS2uicibpMmqicnrqP3dHM5A&s=140&t=1555301651',
    'master_vip_level': 8,
    'personal_code_status': 0,
    'star_code_status': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 今天已经碰过 = {
  'data': {
    'act_name': 'fulishe_dft',
    'actid': 'fulishe_dft',
    'is_today_collision': 1,
    'is_your_code': 0,
    'master_eggs_info': {
      'egg_name': '镀金彩蛋',
      'egg_skin_url': 'https://puui.qpic.cn/vupload/0/1561101327730_l1mnw2i06y/0',
      'eggs_count': 2,
      'eggs_type': 1
    },
    'master_vip_info': {
      'master_id': '135051317',
      'master_is_annual_vip': 1,
      'master_is_vip': 1,
      'master_name': '追风筝的人',
      'master_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=tnS2uicibpMmqicnrqP3dHM5A&s=140&t=1555301651',
      'master_vip_level': 8
    },
    'personal_code_status': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 分享码无效 = {
  'data': {
    'eggs_count': 1,
    'eggs_pic': '',
    'eggs_type': 0,
    'is_today_collision': 1,
    'is_your_code': 0,
    'master_background_url': '',
    'master_big_url': '',
    'master_id': '135051317',
    'master_is_annual_vip': 1,
    'master_is_vip': 1,
    'master_name': '追风筝的人',
    'master_type': 1,
    'master_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=tnS2uicibpMmqicnrqP3dHM5A&s=140&t=1555301651',
    'master_vip_level': 8,
    'personal_code_status': 1,
    'star_code_status': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 今天没蛋了 = {
  'data': {
    'egg_count': 0,
    'egg_name': '普通蛋2',
    'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_dja6unp16w5/0',
    'egg_type': 1,
    'is_played': 1,
    'is_recved': 1,
    'is_shaked': 1,
    'is_yesrecved': 0
  },
  'msg': 'OK',
  'ret': 0
};
export var 碰蛋消息 = {
  'data': {
    'list': [{
      'friends': {
        'egg_type': 0,
        'friends_type': 1,
        'goods_name': '腾讯18周年纪念公仔',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/4A741EC016B2F9E563160BC6281A082E1559629777/0',
        'lottery_result': 1,
        'nick_name': 'nate',
        'nick_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=gKfraF8MPPD0v9lyoReJJA&s=140&t=1555960994'
      },
      'lotteryTime': 1561709093,
      'my': {
        'egg_type': 0,
        'goods_name': '腾讯视频100小说券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/8D9F21EAB0620702A3C65E304A3BBCE71539225789/0',
        'lottery_result': 1
      }
    }, {
      'friends': {
        'egg_type': 0,
        'friends_type': 1,
        'goods_name': '腾讯18周年纪念公仔',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/4A741EC016B2F9E563160BC6281A082E1559629777/0',
        'lottery_result': 1,
        'nick_name': 'nate',
        'nick_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=gKfraF8MPPD0v9lyoReJJA&s=140&t=1555960994'
      },
      'lotteryTime': 1561709093,
      'my': {
        'egg_type': 0,
        'goods_name': '腾讯视频100小说券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/8D9F21EAB0620702A3C65E304A3BBCE71539225789/0',
        'lottery_result': 1
      }
    }]
  },
  'msg': 'OK',
  'ret': 0
};
export var 碰蛋记录 = {
  'data': {
    'list': [{
      'is_active': 2,
      'lottery_time': 1562836039,
      'my': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'goods_name': '碰蛋镀金-200元漫画券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/A7593DEC18676A6A39E3636D05ED7A951562574559/0',
        'lottery_result': 1
      }
    }, {
      'friends': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'lottery_result': 1,
        'nick_name': '小哥',
        'nick_url': 'http://thirdwx.qlogo.cn/mmopen/vi_32/k5aHV9xvVfKT8mMlqEBhoBRUbck5zosPLqVJLJzPj4dicVgETFVWK9ibGb8awavaNd50MCEenJm56r6qeEEibP45w/132'
      },
      'is_active': 0,
      'lottery_time': 1562745589,
      'my': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'goods_name': '碰蛋镀金-200元小说券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/F77FBB130C04E23A3708C0DE74A121EE1562573885/0',
        'lottery_result': 1
      }
    }, {
      'friends': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'lottery_result': 1,
        'nick_name': '小哥',
        'nick_url': 'http://thirdqq.qlogo.cn/g?b=sdk&k=sNxCibkRGFIZC71ricXYv3Rw&s=140&t=1555856957'
      },
      'is_active': 0,
      'lottery_time': 1562745534,
      'my': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'goods_name': '碰蛋镀金-100元漫画券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/860A067AF7DE42E53AA986DC184F1C231562660456/0',
        'lottery_result': 1
      }
    }, {
      'is_active': 2,
      'lottery_time': 1562730343,
      'my': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'goods_name': '碰蛋镀金-200元小说券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/F77FBB130C04E23A3708C0DE74A121EE1562573885/0',
        'lottery_result': 1
      }
    }, {
      'is_active': 2,
      'lottery_time': 1562730343,
      'my': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'goods_name': '碰蛋镀金-200元小说券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/F77FBB130C04E23A3708C0DE74A121EE1562573885/0',
        'lottery_result': 0
      }
    }, {
      'friends': {
        'egg_name': '普通蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/1561101327730_l1mnw2i06y/0',
        'egg_type': 0,
        'lottery_result': 1,
        'nick_name': 'rdgztest_94668111111111111111111',
        'nick_url': 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLdDQkMW9wYz5HXhAe0beGmq9kJbFBFV7oGupG58xVEOoyeAj58nZKcwjL660ftYIWWKrRQFpeLUw/132'
      },
      'is_active': 0,
      'lottery_time': 1562730343,
      'my': {
        'egg_name': '镀金彩蛋1',
        'egg_skin_url': 'https://puui.qpic.cn/vupload/0/20190708_sln3ovaqe8/0',
        'egg_type': 1,
        'goods_name': '碰蛋镀金-200元小说券',
        'goods_url': 'https://puui.qpic.cn/vshpic/0/F77FBB130C04E23A3708C0DE74A121EE1562573885/0',
        'lottery_result': 0
      }
    }]
  },
  'msg': '',
  'ret': 0
};